/* eslint-disable */
import React, { useState, useEffect } from 'react';
import { UncontrolledCollapse } from 'reactstrap';
import { FormGroup, Button } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSearch, faEraser, faPlus } from '@fortawesome/free-solid-svg-icons';
import {
  GET_BANCO_IMAGEM_CATEGORIAS,
  GET_BANCO_IMAGEM_CONTEUDOS,
} from 'services/BancoImagem';
import {
  GET_LIST_MARCA,
  GET_LIST_CATEGORIA,
  GET_LIST_GRUPO,
} from 'services/ProdutoCategoria';

import './styles.scss';

const Filter = (props) => {
  const [marcas, setMarcas] = useState([]);
  const [marcasSelecionadas, setMarcasSelecionadas] = useState([]);

  const [categorias, setCategorias] = useState([]);
  const [categoriasFiltradas, setCategoriasFiltradas] = useState([]);
  const [categoriasSelecionadas, setCategoriasSelecionadas] = useState([]);

  const [grupos, setGrupos] = useState([]);
  const [gruposFiltrados, setGruposFiltrados] = useState([]);
  const [gruposSelecionados, setGruposSelecionados] = useState([]);

  const [categoriaImagens, setCategoriaImagens] = useState([]);
  const [categoriaImagensSelecionadas, setCategoriaImagensSelecionadas] =
    useState([]);

  const [conteudoImagens, setConteudoImagens] = useState([]);
  const [conteudoImagensSelecionadas, setConteudoImagensSelecionadas] =
    useState([]);

  const [texto, setTexto] = useState('');

  function onChangeTexto(event) {
    const { value, name } = event.target;
    setTexto(value);
  }

  const onChangeCategoriaImagens = (event) => {
    let catImagens = categoriaImagensSelecionadas;
    if (event.target.checked) {
      const item = catImagens.find(
        (item) => item === parseFloat(event.target.value)
      );

      if (!item) {
        catImagens.push(parseFloat(event.target.value));
      }
    } else {
      const item = catImagens.find(
        (item) => item === parseFloat(event.target.value)
      );
      const indexItem = catImagens.findIndex(
        (item) => item === parseFloat(event.target.value)
      );

      if (item) {
        catImagens.splice(indexItem);
      }
    }

    setCategoriaImagensSelecionadas(catImagens);
  };

  const onChangeConteudoImagens = (event) => {
    let catImagens = conteudoImagensSelecionadas;
    if (event.target.checked) {
      const item = catImagens.find(
        (item) => item === parseFloat(event.target.value)
      );

      if (!item) {
        catImagens.push(parseFloat(event.target.value));
      }
    } else {
      const item = catImagens.find(
        (item) => item === parseFloat(event.target.value)
      );
      const indexItem = catImagens.findIndex(
        (item) => item === parseFloat(event.target.value)
      );

      if (item) {
        catImagens.splice(indexItem);
      }
    }

    setConteudoImagensSelecionadas(catImagens);
  };

  const onChangeMarcas = (event) => {
    const elementValue = parseInt(event.target.value);
    const $element = event.target;
    let marcas = marcasSelecionadas;
    let items = [];

    if ($element.checked) {
      const itemMarca = marcas.find((marca) => marca === elementValue);

      if (!itemMarca) {
        marcas.push(elementValue);
      }
      setMarcasSelecionadas([...marcas]);
    } else {
      let newMarcas = [];

      for (let i = 0; i < marcas.length; i++) {
        if (marcas[i] !== elementValue) {
          newMarcas.push(marcas[i]);
        }
      }

      setMarcasSelecionadas(newMarcas);
    }
  };

  useEffect(() => {
    let items = [];

    if (!marcasSelecionadas?.length || marcasSelecionadas.length === 0) {
      items = categorias;
    } else {
      items = categorias.filter(
        (c) =>
          marcasSelecionadas.findIndex(
            (marcaId) => marcaId === c.produtoCategoriaSuperiorId
          ) !== -1
      );
    }

    const distinctByName = [];
    for (var i = 0; i < items.length; i++) {
      const index = distinctByName.findIndex((x) => x.nome === items[i].nome);
      if (index === -1) {
        let produtoCategoria = {
          ...items[i],
          categoriaIds: [items[i].produtoCategoriaId],
        };

        produtoCategoria.checked = categoriasFiltradas.find(
          (c) =>
            c.categoriaIds.findIndex(
              (produtoCategoriaId) =>
                produtoCategoriaId === produtoCategoria.produtoCategoriaId
            ) !== -1
        )?.checked;

        distinctByName.push(produtoCategoria);
      } else {
        let produtoCategoria = items[i];

        distinctByName[index].checked =
          distinctByName[index].checked ||
          categoriasFiltradas.find(
            (c) =>
              c.categoriaIds.findIndex(
                (produtoCategoriaId) =>
                  produtoCategoriaId === produtoCategoria.produtoCategoriaId
              ) !== -1
          )?.checked;

        distinctByName[index].categoriaIds.push(
          produtoCategoria.produtoCategoriaId
        );
      }
    }

    setCategoriasFiltradas(distinctByName);

    updateCategoriasSelecionadas(distinctByName);
  }, [categorias, marcasSelecionadas]);

  const onChangeCategoriaProdutos = (event) => {
    const elementValue = parseInt(event.target.value);

    const item = categoriasFiltradas.find(
      (categoria) => categoria.produtoCategoriaId === elementValue
    );
    item.checked = event.target.checked;

    updateCategoriasSelecionadas(categoriasFiltradas);
  };

  const updateCategoriasSelecionadas = (categoriasFiltradas) => {
    const itensChecados = [].concat(
      ...categoriasFiltradas.filter((x) => x.checked).map((x) => x.categoriaIds)
    );

    setCategoriasSelecionadas(itensChecados);
  };

  useEffect(() => {
    let items = [];

    if (
      (!categoriasSelecionadas?.length ||
        categoriasSelecionadas.length === 0) &&
      (!categoriasFiltradas?.length || categoriasFiltradas.length === 0)
    ) {
      items = grupos;
    } else {
      if (categoriasSelecionadas?.length) {
        items = grupos.filter(
          (g) =>
            categoriasSelecionadas.findIndex(
              (categoriaId) => categoriaId === g.produtoCategoriaSuperiorId
            ) !== -1
        );
      } else if (categoriasFiltradas.length) {
        const categoriaIds = [].concat(
          ...(categoriasFiltradas || []).map((x) => x.categoriaIds)
        );

        items = grupos.filter(
          (g) =>
            categoriaIds.findIndex(
              (categoriaId) => categoriaId === g.produtoCategoriaSuperiorId
            ) !== -1
        );
      }
    }

    const distinctByName = [];
    for (var i = 0; i < items.length; i++) {
      const index = distinctByName.findIndex((x) => x.nome === items[i].nome);
      if (index === -1) {
        let produtoCategoria = {
          ...items[i],
          categoriaIds: [items[i].produtoCategoriaId],
        };

        produtoCategoria.checked = gruposFiltrados.find(
          (c) =>
            c.categoriaIds.findIndex(
              (produtoCategoriaId) =>
                produtoCategoriaId === produtoCategoria.produtoCategoriaId
            ) !== -1
        )?.checked;

        distinctByName.push(produtoCategoria);
      } else {
        let produtoCategoria = items[i];

        distinctByName[index].checked =
          distinctByName[index].checked ||
          gruposFiltrados.find(
            (c) =>
              c.categoriaIds.findIndex(
                (produtoCategoriaId) =>
                  produtoCategoriaId === produtoCategoria.produtoCategoriaId
              ) !== -1
          )?.checked;

        distinctByName[index].categoriaIds.push(
          produtoCategoria.produtoCategoriaId
        );
      }
    }

    setGruposFiltrados(distinctByName);

    updateGruposSelecionados(distinctByName);
  }, [grupos, categoriasFiltradas, categoriasSelecionadas]);

  const onChangeGrupos = (event) => {
    const elementValue = parseInt(event.target.value);

    const item = gruposFiltrados.find(
      (grupo) => grupo.produtoCategoriaId === elementValue
    );
    item.checked = event.target.checked;

    updateGruposSelecionados(gruposFiltrados);
  };

  const updateGruposSelecionados = (gruposFiltrados) => {
    const itensChecados = [].concat(
      ...gruposFiltrados.filter((x) => x.checked).map((x) => x.categoriaIds)
    );

    setGruposSelecionados(itensChecados);
  };

  const filterImages = () => {
    props.filtrar(
      texto,
      marcasSelecionadas,
      categoriasSelecionadas,
      gruposSelecionados,
      categoriaImagensSelecionadas,
      conteudoImagensSelecionadas
    );
  };

  const clearFilter = () => {
    setCategoriaImagensSelecionadas([]);
    setConteudoImagensSelecionadas([]);
    setCategoriasSelecionadas([]);
    setMarcasSelecionadas([]);
    setGruposSelecionados([]);
    setTexto('');

    const items = document.getElementsByTagName('INPUT');

    for (let loop = 0; loop < items.length; loop++) {
      let item = items[loop];
      if (item.type === 'checkbox' && item.checked) {
        item.checked = false;
      }
    }

    props.filtrar('', [], [], [], []);
  };

  useEffect(() => {
    (async () => {
      const data = await GET_BANCO_IMAGEM_CATEGORIAS();
      setCategoriaImagens(data.value);
    })();

    (async () => {
      const data = await GET_BANCO_IMAGEM_CONTEUDOS();
      setConteudoImagens(data.value);
    })();

    (async () => {
      const listaMarca = await GET_LIST_MARCA();
      setMarcas(listaMarca.value);

      const listaCategorias = await GET_LIST_CATEGORIA();
      setCategorias(listaCategorias.value);

      const listaGrupo = await GET_LIST_GRUPO();
      setGrupos(listaGrupo.value);
    })();
  }, []);

  return (
    <div className="filter-body">
      <div className="titulo">FILTROS</div>
      <div className="body">
        <div className="input">
          <label>Nome ou Código</label>
          <input
            type="text"
            className="form-control"
            onChange={onChangeTexto}
            value={texto}
          />
        </div>

        <hr className="default" />

        <div className="filters">
          <label type="button" className="btn btn-block" id="itensCat">
            Categoria Mídia{' '}
            <FontAwesomeIcon
              className="float-right"
              style={{ marginLeft: '10px' }}
              icon={faPlus}
            />
          </label>
          <UncontrolledCollapse toggler="#itensCat">
            <div>
              {categoriaImagens.map((categoria) => (
                <div key={categoria.bancoImagemCategoriaId}>
                  <label style={{ fontSize: '14px' }}>
                    <input
                      onChange={onChangeCategoriaImagens}
                      type="checkbox"
                      value={categoria.bancoImagemCategoriaId}
                    />{' '}
                    {categoria.nome}
                  </label>
                </div>
              ))}
            </div>
          </UncontrolledCollapse>
        </div>

        <hr className="default" />

        <div className="filters">
          <label type="button" className="btn btn-block" id="itensCon">
            Conteúdo Mídia{' '}
            <FontAwesomeIcon
              className="float-right"
              style={{ marginLeft: '10px' }}
              icon={faPlus}
            />
          </label>
          <UncontrolledCollapse toggler="#itensCon">
            <div>
              {conteudoImagens.map((conteudo) => (
                <div key={conteudo.bancoImagemCategoriaConteudoId}>
                  <label style={{ fontSize: '14px' }}>
                    <input
                      onChange={onChangeConteudoImagens}
                      type="checkbox"
                      value={conteudo.bancoImagemCategoriaConteudoId}
                    />{' '}
                    {conteudo.nome}
                  </label>
                </div>
              ))}
            </div>
          </UncontrolledCollapse>
        </div>

        <hr className="default" />

        <div className="filters">
          <label type="button" className="btn btn-block" id="itensMarca">
            Marca <FontAwesomeIcon className="float-right" icon={faPlus} />
          </label>
          <UncontrolledCollapse toggler="#itensMarca">
            <div>
              {marcas.map((marca) => {
                return (
                  <div key={marca.produtoCategoriaId}>
                    <label style={{ fontSize: '14px' }}>
                      <input
                        onChange={onChangeMarcas}
                        value={marca.produtoCategoriaId}
                        type="checkbox"
                      />{' '}
                      {marca.nome}
                    </label>
                  </div>
                );
              })}
            </div>
          </UncontrolledCollapse>
        </div>

        {/* <div className="filters">
          <label type="button" className="btn btn-block" id="itensProd">
            Categoria <FontAwesomeIcon className="float-right" icon={faPlus} />
          </label>

          <UncontrolledCollapse toggler="#itensProd">
            <div>
              {categoriasFiltradas.map((item) => (
                <div key={`${item.produtoCategoriaId}`}>
                  <label style={{ fontSize: '14px' }}>
                    <input
                      onChange={onChangeCategoriaProdutos}
                      type="checkbox"
                      value={item.produtoCategoriaId}
                      checked={item.checked || false}
                    />{' '}
                    {item.nome}
                  </label>
                </div>
              ))}
            </div>
          </UncontrolledCollapse>
        </div>

        <hr className="default" />
        <div className="filters">
          <label type="button" className="btn btn-block" id="itensGrupo">
            Grupo <FontAwesomeIcon className="float-right" icon={faPlus} />
          </label>

          <UncontrolledCollapse toggler="#itensGrupo">
            <div>
              {gruposFiltrados.map((item) => (
                <div key={`${item.produtoCategoriaId}`}>
                  <label style={{ fontSize: '14px' }}>
                    <input
                      onChange={onChangeGrupos}
                      type="checkbox"
                      value={item.produtoCategoriaId}
                      checked={item.checked || false}
                    />{' '}
                    {item.nome}
                  </label>
                </div>
              ))}
            </div>
          </UncontrolledCollapse>
        </div>
 */}
        <hr className="default" />

        <div className="buttons">
          <FormGroup className="row">
            <div className=" col-lg-12">
              <Button
                onClick={filterImages}
                className="query-button"
                variant="primary"
              >
                <FontAwesomeIcon icon={faSearch} /> Filtrar
              </Button>
              <Button
                onClick={clearFilter}
                className="query-button"
                variant="outline-primary"
              >
                <FontAwesomeIcon icon={faEraser} /> Limpar
              </Button>
            </div>
          </FormGroup>
        </div>
      </div>
    </div>
  );
};

export default Filter;
